export default "__VITE_ASSET__DpHd1J_4__"